module.exports = __webpack_public_path__ + "static/media/logo-vercan-200x76.4edd4034.png";